import { MenuHelper, IMenuDefinition, menuType } from "@/helpers/MenuHelper";
import vuestore from '@/store';
import { AreaSaggioClasseDiametricaStore } from './store/areaSaggioClasseDiametrica.store';
import Counter from "./components/dashboard/counter.vue";
import { dashboardHelper } from '@/helpers/DashboardHelper';
import { securityService } from "@/services/securityService";

export function init() {
  const userRoles  = securityService.getInfo()?.roles;
  if (userRoles.includes("Amministratore") || userRoles.includes("Editore")){
    MenuHelper.addMenuDefinition(
      { name: "areeSaggioClasseDiametrica", class: "indent-1", description: "Rilievo cavallettamento", icon: "icon-uf_areesaggio_diam", routeName: "ClasseDiametrica", orderIndex: 1, group: "Censimento in situ" } as IMenuDefinition,
      { section: menuType.drawer },
      { section: menuType.bottom });
    dashboardHelper.addComponent(Counter, "insitu");
  }

  //REGISTRAZIONE DELLO STORE
  vuestore.registerModule(AreaSaggioClasseDiametricaStore.PREFIX, AreaSaggioClasseDiametricaStore);
};
